/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { LinkButton, Text } from '@blend/enterprise-components';

import { respondToAuthChallenge } from 'blb-api/auth';
import { BlendBridge } from 'blb-types/blendBridge';
import { SetUser } from 'blb-ui-types/login';
import { FormCard } from 'blb-components/FormCard';
import { useChallengeCookie, useLoginFlowSubmit } from 'blb-utils/login';

export namespace EmailMFAForm {
  export interface Props {
    setMe: SetUser;
    setUseEmailMFA: (bool: boolean) => void;
  }
}

export const EmailMFAForm: React.FC<EmailMFAForm.Props> = ({ setMe, setUseEmailMFA }) => {
  const challengeCookieResult = useChallengeCookie();
  const { username } = challengeCookieResult.cookie as BlendBridge.API.UpdatePasswordChallengeCookie;

  const getEmailMFAFormValues = () => ({ mfaType: 'EMAIL' });
  const onEmailMFASubmit = useLoginFlowSubmit(respondToAuthChallenge, setMe, getEmailMFAFormValues);

  return (
    <FormCard<BlendBridge.API.UpdateMFATypeChallenge>
      headerLabel={
        <Text>
          For future logins, Blend will use the following email <Text weight="bold">{username}</Text> to send you a
          secure link to complete your login.
        </Text>
      }
      headerTitle="Email Verification"
      id="SetupMFA-Email"
      onSubmit={onEmailMFASubmit}
      showCancel={false}
      submitLabel="Complete activation"
    >
      <Text fontSize="sm" weight="medium">
        Want to use a mobile phone number instead?{' '}
        <LinkButton btnSize="sm" id="it-EmailMFA" inline label="Go back." onClick={() => setUseEmailMFA(false)} />
      </Text>
    </FormCard>
  );
};
